import { render, staticRenderFns } from "./PoStockItems.vue?vue&type=template&id=5f5d4d46&scoped=true&"
import script from "./PoStockItems.vue?vue&type=script&lang=js&"
export * from "./PoStockItems.vue?vue&type=script&lang=js&"
import style0 from "./PoStockItems.vue?vue&type=style&index=0&id=5f5d4d46&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f5d4d46",
  null
  
)

export default component.exports